import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import { GET_ME_QUERY_KEY } from './useGetMe';

import { MeResponse } from '@/services/AuthService';
import CustomerService, {
  UpdateShopifyAdditionalSettingsDto,
} from '@/services/CustomerService';

export function useUpdateShopifyAdditionalSettings() {
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: (dto: UpdateShopifyAdditionalSettingsDto) =>
      CustomerService.updateShopifyAdditionalSettings(dto),
    onMutate: (variables) => {
      const previousData =
        queryClient.getQueryData<MeResponse>(GET_ME_QUERY_KEY);

      queryClient.setQueryData<MeResponse>(
        GET_ME_QUERY_KEY,
        produce((draft) => {
          if (draft?.customer) {
            draft.customer.shopifyPublicationIds =
              variables.shopifyPublicationIds;

            draft.customer.shopifyExcludedVendors =
              variables.shopifyExcludedVendors;

            draft.customer.shopifyOrderSource = variables.shopifyOrderSource;
          }
        }),
      );

      return { previousData };
    },
    onError: (_error, _data, context) => {
      queryClient.setQueryData<MeResponse>(
        GET_ME_QUERY_KEY,
        context?.previousData,
      );
    },
  });

  return {
    updateShopifyAdditionalSettings: mutateAsync,
    isLoading: isPending,
  };
}
